import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { Technology, EnvironmentConfig } from "../../../../../../redux/slices/projects/Types";
import "./IntegrationSandboxSection.scss";

type IntegrationSandboxSectionProps = {
  technology: Technology;
};

type EnvColumn = {
  heading: string;
  data: EnvironmentConfig;
  sandboxAppId?: string;
};

const FIELD_LABELS: { key: keyof EnvironmentConfig | "sandbox_app_id"; label: string }[] = [
  { key: "test_org_name", label: "Test ORG Name:" },
  { key: "test_org_id", label: "Test ORG ID" },
  { key: "org_admin", label: "ORG Admin" },
  { key: "sandbox_app_id", label: "Sandbox Application ID" },
];

const IntegrationSandboxSection: React.FC<IntegrationSandboxSectionProps> = ({
  technology,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const columns: EnvColumn[] = [
    {
      heading: "CERT",
      data: technology.cert,
      sandboxAppId: technology.sandbox_application_id?.cert,
    },
    {
      heading: "Preprod",
      data: technology.preprod,
      sandboxAppId: technology.sandbox_application_id?.preprod,
    },
    {
      heading: "Prod",
      data: technology.prod,
      sandboxAppId: technology.sandbox_application_id?.prod,
    },
  ];

  return (
    <div className="integration-sandbox-section">
      <button
        type="button"
        className="integration-sandbox-section__header"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
      >
        <div className="integration-sandbox-section__heading">
          <h3 className="integration-sandbox-section__title">Sandbox</h3>
          <p className="integration-sandbox-section__subtitle">
            Emails, website, phone &amp; location
          </p>
        </div>
        <Iconography
          icon={isOpen ? "chevronUp" : "chevronDown"}
          size={IconographySizes.Small}
        />
      </button>

      {isOpen ? (
        <div className="integration-sandbox-section__body">
          <div className="integration-sandbox-section__grid">
            {columns.map((col) => (
              <div key={col.heading} className="integration-sandbox-section__column">
                <div className="integration-sandbox-section__col-heading">
                  {col.heading}
                </div>
                {FIELD_LABELS.map(({ key, label }) => {
                  const value =
                    key === "sandbox_app_id"
                      ? col.sandboxAppId
                      : col.data[key];
                  return (
                    <div
                      key={key}
                      className="integration-sandbox-section__row"
                    >
                      <span className="integration-sandbox-section__label">
                        {label}
                      </span>
                      <span className="integration-sandbox-section__value">
                        {value || "N/A"}
                      </span>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default IntegrationSandboxSection;
